import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import {
  Box,
  Button,
  Card,
  Typography,
} from '@mui/material'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import { fetchTrackEvent, ProductAnalyticsEventTypes } from 'src/redux/productAnalytics'

const getPendingContent = (wizardData) => {
  const { employerHasActiveSubscription, isConsumerEmail, isNewEmployer, employerName } = wizardData

  if (isNewEmployer) {
    return {
      title: 'We\'re reviewing your organization',
      body: `We're verifying ${employerName} as a new organization on MyStethi. We'll email you once your account is approved.`,
    }
  }

  if (isConsumerEmail) {
    return {
      title: 'We\'re verifying your account',
      body: `Since you registered with a personal email, we need to verify your association with ${employerName}. We'll email you once your account is approved.`,
    }
  }

  if (employerHasActiveSubscription) {
    return {
      title: 'Your organization is already on MyStethi',
      body: `Your request to join ${employerName} has been sent for approval. We'll email you once your account is approved.`,
    }
  }

  return {
    title: 'Account under review',
    body: 'We\'re reviewing your account. We\'ll email you once your account is approved.',
  }
}

const EmployerUserPendingApprovalStep = ({ wizardData }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(
      fetchTrackEvent({
        eventName: 'signup_pending_approval_viewed',
        eventType: ProductAnalyticsEventTypes.ACTION,
        distinctId: wizardData.email,
        eventData: {
          employerId: wizardData.employerId,
          employerName: wizardData.employerName,
          isConsumerEmail: wizardData.isConsumerEmail,
          isNewEmployer: wizardData.isNewEmployer,
          employerHasActiveSubscription: wizardData.employerHasActiveSubscription,
        },
      }),
    )
  }, [dispatch, wizardData.email, wizardData.employerId, wizardData.employerName, wizardData.isConsumerEmail, wizardData.isNewEmployer, wizardData.employerHasActiveSubscription])

  const { title, body } = getPendingContent(wizardData)

  return (
    <Box sx={{ pt: 6, pb: 10, display: 'flex', justifyContent: 'center' }}>
      <Card
        elevation={2}
        sx={{
          textAlign: 'center',
          borderRadius: '12px',
          p: { xs: 4, md: 5 },
          maxWidth: 520,
          width: '100%',
        }}
      >
        <HourglassEmptyIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
        <Typography variant='h4' fontWeight={700} gutterBottom>
          {title}
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ mb: 2 }}>
          {body}
        </Typography>
        <Button
          variant='contained'
          size='large'
          onClick={() => navigate('/')}
        >
          Go to MyStethi
        </Button>
      </Card>
    </Box>
  )
}

export default EmployerUserPendingApprovalStep
